
import React from "react";
import { LogOut } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

interface SidebarUserProps {
  user: any;
  onLogout: () => void;
  isCollapsed?: boolean;
}

const SidebarUser: React.FC<SidebarUserProps> = ({ user, onLogout, isCollapsed = false }) => {
  if (!user) return null;

  return (
    <div className={`mb-4 ${isCollapsed ? "px-2" : "px-4"}`}>
      <div className={`flex items-center gap-3 p-2 rounded-md ${isCollapsed ? "justify-center" : ""}`}>
        <Avatar className="w-10 h-10 border border-sidebar-border">
          <AvatarImage src={user?.user_metadata?.avatar_url} />
          <AvatarFallback>
            {user?.email?.charAt(0).toUpperCase() || 'U'}
          </AvatarFallback>
        </Avatar>
        {!isCollapsed && (
          <>
            <div className="flex flex-col flex-1 min-w-0">
              <span className="text-sm font-medium text-sidebar-foreground truncate">
                {user?.user_metadata?.full_name || user?.email?.split('@')[0] || 'User'}
              </span>
              <span className="text-xs text-sidebar-foreground/70 truncate">{user?.email}</span>
            </div>
            <button
              onClick={onLogout}
              className="p-1 hover:bg-sidebar-accent rounded transition-colors flex-shrink-0"
              title="Sign out"
            >
              <LogOut className="w-4 h-4 text-sidebar-foreground/70" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default SidebarUser;
